



































































































import { Component, Vue, Inject} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import Appconst from '../../../lib/appconst'
import ContractAddForm from './contractAddForm.vue'
@Component({
    name:'contractAddAgreementDetail',
    components: {
        ContractAddForm
    }
})
export default class ContractAddAgreementDetail extends AbpBase {
    initData:any = {
        detailData: {
            loading: true,
            contraceCode: null
        },
        editData: {
            content: {},
            status: false,
            loading: true,
            btnLoading: true,
            contractMainType: 3
        },
        verifyData: {
            status: false,
        },
        addAgreement: {
            status: false,
            btnLoading: true,
            content: {}
        },
        fileUrl: Appconst.fileUrl,
        showAudit: false,
        invalid:{
            loading:false
        }
    }

    //编辑弹窗
    async EditModal() {
        this.initData.editData.content = (this as any).$root.copyObj(this.initData.detailData);
        this.initData.editData.status = true;
        this.initData.editData.loading = false;
    }
    //审核弹窗-操作
    async VerifyModalAction(type:any) {
        let data:any = {
            catalog: 3,
            isAuditPass: !!type,
            contractId: ~~this.initData.id
        };
        this.initData.verifyData.status = false;
        if(type){
            await Ajax.post('/api/services/app/Contract/ContractAuditAsync', data).then((res:any)=>{
                this.$Modal.success({
                    title: '合同登记审核',
                    content: '合同审核通过，已为该合同分配唯一编号：' + res.data.result.contraceCode
                });
                this.GetData();
            });
        }else{
            this.$Modal.confirm({
                title: '合同登记审核',
                content: '确定要驳回该合同吗？',
                onOk: async ()=>{                        
                    await Ajax.post('/api/services/app/Contract/ContractAuditAsync', data);
                    this.$Message.success('操作成功!');
                    this.GetData();
                }
            })
        }
    }

    //作废弹窗
    InvalidModal(){
        this.initData.invalid.loading = !this.initData.invalid.loading;
    }
    async InvalidBtn(){
        await Ajax.post('/api/services/app/Contract/ContractNullifyAsyncc',{id:this.initData.id});
        this.$Modal.success({
            title: '提示',
            content: '作废成功！'
        });
        this.GetData();
    }
    //处理异步弹窗关闭
    setAsyncModalClose(type:any) {
        this.initData[type].status = false;
    }
    //合同登记弹窗-关闭回调
    AddModalClose(status:any){
        this.initData.editData.btnLoading = status;
    }
    //合同登记弹窗-关闭重置表单
    RestForm(status:any){
        (this.$refs.ContractAddForm as any).RestForm(status);
    }
    //合同登记弹窗-关闭
    CloseAddModal(status:any){
        this.initData.editData.status = status;
    }

    //提交
    Submit(type:any) {
        (this.$refs.ContractAddForm as any).Submit(type);
    }
    async GetDic() {
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.initData.showAudit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.Audit'];
        this.initData.allowEdit = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.MaintainAudited'];
        this.initData.allowNullify = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.Nullify'];
    }
    async GetData() {
        this.initData.detailData = (await Ajax.get('/api/services/app/Contract/GetSupplementDetailInfoAsync?id=' + this.initData.id)).data.result;
        this.initData.detailData.loading = false;
    }
    //日期过滤器
    filters:any = {
        formatDate: (date:any)=>{
            if(date){
                return date.substring(0,10);
            }else{
                return '-';
            }
        }
    }
    async mounted() {
        this.initData.id = this.$route.query.id;
        await this.GetDic();
        this.GetData();
    }
}
